import { createVuetify, type IconProps, type IconSet, type ThemeDefinition } from 'vuetify'
import { md } from 'vuetify/iconsets/md'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { defineComponent, h, onMounted, ref } from 'vue'
import { VImg } from 'vuetify/components/VImg'

const lightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary: '#6D00E7',
    secondary: '#ffc941',
    tertiary: '#495057',
    accent: '#82B1FF',
    error: '#f55a4e',
    info: '#00d3ee',
    success: '#5cb860',
    warning: '#ffa21a',
    background: '#EFEFEF',
    application: '#EFEFEF',
    gray: '#D0D5DD',
  },
  variables: {},
}

const btnProps = {
  color: 'primary',
  variant: 'elevated',
}

const IconMap: Record<string, () => Promise<typeof import('*.png')>> = {
  'car-wash': () => import('@/images/icons/car-wash.png'),
}

const cw: IconSet = {
  component: defineComponent({
    props: {
      icon: {
        type: String,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    setup(props: IconProps) {
      const src = ref('') // This will eventually store the resolved image URL.

      onMounted(async () => {
        // Call the corresponding function to import the image on mount.
        if (typeof props.icon === 'string' && IconMap[props.icon]) {
          const module = await IconMap[props.icon]()
          // Vite returns the final asset URL as the default export.
          src.value = module.default
        }
      })

      return { src }
    },
    render() {
      // Until the image is loaded, src may be an empty string.
      return h(VImg, { src: this.src, ...this.$props })
    },
  }),
}

export default createVuetify({
  theme: {
    defaultTheme: 'lightTheme',
    variations: {
      colors: ['primary', 'secondary'],
      lighten: 2,
      darken: 2,
    },
    themes: {
      lightTheme,
    },
  },
  defaults: {
    VTextField: {
      counter: 255,
      rules: [
        (value: string) =>
          (String(value) ? String(value).length : 0) <= 255 || 'Max 255 characters',
      ],
    },
    VCardActions: {
      VBtn: btnProps,
    },
    VBtn: btnProps,
    VToolbar: {
      VBtn: btnProps,
    },
  },
  date: {
    formats: {
      date: 'MM/DD/YYYY',
      datetime: 'MM/DD/YYYY HH:mm',
      time: 'HH:mm',
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
      md,
      cw,
    },
  },
})
